(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    function build (project) {
      return (root.AJS = factory(project));
    }
    define('AJS', build);
    build();
  } else if (typeof module === 'object' && module.exports) {
    module.exports = factory(require('AJS'));
  } else {
    root.AJS = factory(root.AJS);
  }
}(this || window, function (project) { AJS = "AJS" in this ? this.AJS : { I18n: { keys: {} } };
AJS.I18n.keys['cp.footer.expand.minimode'] = 'Show all files';
AJS.I18n.keys['cp.footer.close.minimode'] = 'Hide all files';
AJS.I18n.keys['cp.thumbnail.description'] = 'View a larger version of {0}';
AJS.I18n.keys['cp.expand.thumbnail.minimode'] = 'Show all files';
AJS.I18n.keys['cp.close.thumbnail.minimode'] = 'Hide all files';
AJS.I18n.keys['cp.go.to.prev'] = 'Go to the previous file';
AJS.I18n.keys['cp.go.to.next'] = 'Go to the next file';
AJS.I18n.keys['cp.go.to.prev.page'] = 'Previous page';
AJS.I18n.keys['cp.go.to.next.page'] = 'Next page';
AJS.I18n.keys['cp.close'] = 'Close';
AJS.I18n.keys['cp.download.original'] = 'Download';
AJS.I18n.keys['cp.fit.to.page'] = 'Fit to page';
AJS.I18n.keys['cp.zoom.in'] = 'Zoom in';
AJS.I18n.keys['cp.zoom.out'] = 'Zoom out';
AJS.I18n.keys['cp.enter.presentation.mode'] = 'Start Presentation';
AJS.I18n.keys['cp.exit.presentation.mode'] = 'Exit Presentation';
AJS.I18n.keys['cp.image.load.fail.header'] = 'Image could not be loaded.';
AJS.I18n.keys['cp.image.load.fail'] = 'Unable to load file from {0}.';
AJS.I18n.keys['cp.show.more'] = 'More';
AJS.I18n.keys['cp.edit.file'] = 'Edit file';
AJS.I18n.keys['cp.print.file'] = 'Print';
AJS.I18n.keys['cp.delete.file'] = 'Delete';
AJS.I18n.keys['cp.arrow.left.disabled'] = 'You\'re viewing the least recent file';
AJS.I18n.keys['cp.arrow.right.disabled'] = 'You\'re viewing the most recent file';
AJS.I18n.keys['cp.password.protected'] = 'Enter the password to open this file:';
AJS.I18n.keys['cp.password.needed'] = 'Enter the password to open this file:';
AJS.I18n.keys['cp.password.incorrect'] = 'Invalid password. Please try again.';
AJS.I18n.keys['cp.password.input.placeholder'] = 'Password';
AJS.I18n.keys['cp.password.button.ok'] = 'OK';
AJS.I18n.keys['cp.password.fullscreen.title'] = 'This file is password protected.';
AJS.I18n.keys['cp.password.fullscreen.message'] = 'Due to technical reasons you have to leave presentation mode to enter the password.';
AJS.I18n.keys['cp.error.button.download'] = 'Download';
AJS.I18n.keys['cp.error.button.browser'] = 'Open in browser';
AJS.I18n.keys['cp.error.image.missing.header'] = 'Ouch! We can\'t load the image.';
AJS.I18n.keys['cp.error.pdf.missing.header'] = 'Ouch! We can\'t load the PDF.';
AJS.I18n.keys['cp.error.media.default.header'] = 'Ouch! We can\'t load the media file.';
AJS.I18n.keys['cp.error.pdf.password.header'] = 'Ouch! We can\'t show password protected files yet.';
AJS.I18n.keys['cp.error.pdf.password.message'] = 'Try downloading the file to view it.';
AJS.I18n.keys['cp.error.pdf.invalid.header'] = 'Ouch! Looks like this document is broken.';
AJS.I18n.keys['cp.error.pdf.invalid.message'] = 'Try downloading the file to view it.';
AJS.I18n.keys['cp.error.pdf.default.header'] = 'Ouch! Something is wrong with this file.';
AJS.I18n.keys['cp.error.pdf.default.message'] = 'Try downloading the file to view it.';
AJS.I18n.keys['cp.error.default.header'] = 'Ouch! We can\'t preview this file.';
AJS.I18n.keys['cp.error.file.not.found'] = 'The file does not exist.';
AJS.I18n.keys['cp.error.file.no.viewer'] = 'There is no viewer for this file type.';
AJS.I18n.keys['cp.file.converting.message.header'] = 'Your preview is on its way!';
AJS.I18n.keys['cp.file.converting.message.text'] = 'In a hurry? You can download the original right now.';
AJS.I18n.keys['cp.unknown.file.type.header'] = 'Ouch! We can\'t preview this file type.';
AJS.I18n.keys['cp.unknown.file.type.download.to.view'] = 'Try downloading the file to view it.';
AJS.I18n.keys['cp.unknown.file.type.downloadbutton'] = 'Download';
AJS.I18n.keys['cp.unsupported.browser.header'] = 'Your browser can\'t preview this file.';
AJS.I18n.keys['cp.unsupported.browser.download.to.view'] = 'You\'ll have to download the file or use a different browser to view it.';
AJS.I18n.keys['cp.3d.file.type.toggle.grid'] = 'Toggle Grid';
AJS.I18n.keys['cp.3d.file.type.toggle.camera.type'] = 'Toggle Camera Type';
AJS.I18n.keys['cp.3d.file.type.toggle.light.type'] = 'Toggle Scene Light';
AJS.I18n.keys['cp.3d.file.type.toggle.axis'] = 'Toggle Axis'; return AJS; }));